module.exports = __webpack_public_path__ + "img/avatar_3.63512f16.svg";